import {AxiosResponse} from 'axios'

export class FileProvider {
    /**
     * @description Forces a file download by creating a clickable link on the DOM
     */
    ForceFileDownload(response: AxiosResponse<any>): void {
        const fileName = this.GetFileNameByContentDisposition(response.headers['content-disposition']);

        // Ensure we have a valid file name
        if (!fileName) {
            return
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)
    }

    /**
     * @description Parses the file name from the content-disposition header
     */
    GetFileNameByContentDisposition(contentDisposition: any): string | null {
        // Ensure the disposition header is valid
        if (!contentDisposition) {
            return null
        }

        const regex = /filename[^;=\n]*=(UTF-8(['"]*))?(.*)/;
        const matches = regex.exec(contentDisposition);
        let filename: string | null = null;

        if (matches != null && matches[3]) {
            filename = matches[3].replace(/['"]/g, '')
        }

        if (filename == null) {
            return null
        }

        filename = decodeURI(filename);

        if (filename.indexOf(';')) {
            filename = filename.substring(0, filename.indexOf(';'))
        }

        return filename
    }
}

export default new FileProvider();
